module.exports = __webpack_public_path__ + "static/Apercu-f1b39605596a89ae82422b7c8670a017.ttf";